import StaffEvaluationConfig from './StaffEvaluationConfig';
export default class StaffEvaluation {

    //constructor
    constructor(config, kindergarten, theoreticalHoursPerWeek, actualHoursPerWeekAtDates, date) {
        this.config = config;
        this.kindergarten = kindergarten;
        this.theoreticalHoursPerWeek = theoreticalHoursPerWeek;
        this.actualHoursPerWeekAtDates = actualHoursPerWeekAtDates;
        this.date = date;
    }

    getDiffHoursPerWeek(date) {
        const actualHoursPerWeek = this.getActualHoursPerWeek(date);
        return Math.round((this.theoreticalHoursPerWeek - actualHoursPerWeek) * 100) / 100
    }

    getActualHoursPerWeek(date) {
        return this.actualHoursPerWeekAtDates.find((value) => date === value.date).actualHoursPerWeek;
    }

    static fromData(data)
    {
        if (!data) {
            return;
        }

        return new StaffEvaluation(
            StaffEvaluationConfig.fromData(data.config),
            data.kindergarten,
            data.theoreticalHoursPerWeek,
            data.actualHoursPerWeekAtDates,
        );
    }

    serialize()
    {
        return {
            theoreticalHoursPerWeek: this.theoreticalHoursPerWeek,
            config: {
                thresholdSevereDeviation: this.config.thresholdSevereDeviation,
                thresholdDeviation: this.config.thresholdDeviation,
                thresholdNegativeDeviation: this.config.thresholdNegativeDeviation,
                thresholdUnit: this.config.thresholdUnit
            },
        }
    }
}
